module.exports = __webpack_public_path__ + "img/gift1.72cd0efa.png";